import styled from 'styled-components'
import { Col } from 'react-styled-flexboxgrid-tmp'
import { NoMarginRow } from 'Components/EnhacedFlexboxGrid'


export const _BuildingPreviewCol = styled(Col)`
  padding: 0 0.25rem;
  position: relative;
  max-width: 278px;
  @media screen and (max-width: 1023px) {
    flex-basis: 100%;
/*    max-width: 270px;*/
  }
`
const mobileStyle = `
  flex-wrap: nowrap;
  overflow: scroll;
  padding-bottom: 10px;
  @media screen and (max-width: 768px) {
    -webkit-overflow-scrolling: touch;
  }
`

export const _SimilarBuildingContainer = styled(NoMarginRow)`
  width: 100%;


  .embla {
    --slide-size: auto;
  }
  @media screen and (max-width: 1023px) {
    max-width: 100%;
  }
  ${(props) => ((props.isMobile && mobileStyle) || '')}
`

